import { getAuth, signInAnonymously } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, query, orderBy, getDocs, onSnapshot, updateDoc, addDoc, where, Timestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDbLG_u06TP5tEKe0mRwOA_DrLlWncibt8",
  authDomain: "abuse-counter-87e3c.firebaseapp.com",
  projectId: "abuse-counter-87e3c",
  storageBucket: "abuse-counter-87e3c.firebasestorage.app",
  messagingSenderId: "508935445689",
  appId: "1:508935445689:web:c12db8b7042db8b49a8f68",
  measurementId: "G-H9DGF3MGR1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

signInAnonymously(auth)
  .then(() => {
    console.log("User signed in anonymously");
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error("Error during anonymous sign-in: ", errorCode, errorMessage);
  });

auth.onAuthStateChanged((user) => {
  if (user) {
    console.log("User is signed in with ID:", user.uid);
  } else {
    console.log("User is signed out");
  }
});

export {
  db,
  auth,
  collection,
  query,
  orderBy,
  getDocs,
  addDoc,
  where,
  onSnapshot,
  updateDoc,
  Timestamp
};
